/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/theater/showtimes/desktop.app.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'theater/showtimes/desktop.app', exports: {} };
const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { fd_location as fd_location_updateLocation_getLocation } from '@take-2/fd-modules/splits/require-global';

const { updateLocation, getLocation } = fd_location_updateLocation_getLocation;


import { fd_location_form_creation as locationFormCreation } from '@take-2/fd-modules/splits/require-global';



import { Fandango_debugLog as debugLog } from '@take-2/fd-modules/splits/require-core';



import theater_shared_tdpLocationHelper_updateLocationURL_resolveUrlLocation from '@take-2/fd-modules/theater/shared/tdpLocationHelper';

const { updateLocationURL, resolveUrlLocation } = theater_shared_tdpLocationHelper_updateLocationURL_resolveUrlLocation;


import calendarUI from '@take-2/fd-modules/theater/showtimes/calendarUI';



import hearts from '@take-2/fd-modules/shared/utils/hearts';



import locationHelpers from '@take-2/fd-modules/theater/showtimes/locationHelpers';



import historyStates from '@take-2/fd-modules/movie/shared/historyStates';



import movieShowtimeGroupings from '@take-2/fd-modules/theater/showtimes/movieShowtimeGroupings';



import openChainFilter from '@take-2/fd-modules/theater/showtimes/openChainFilterDesktop';



import theaterConcessionAmenity from '@take-2/fd-modules/theater/shared/theaterConcessionAmenity';



import { shared_global_globalTooltipModule as globalTooltipModule } from '@take-2/fd-modules/splits/require-global';



const Selectors = {
    LOCATION: '#theaters-module-location',
    SUB_NAV_LOCATION: '.js-subnav__user-location',
    GLOBAL_TOOLTIP_PLACEHOLDER: '#global-tooltip-placeholder-showtimes', // For global tooltip positioning
}


const Styles = {
    GLOBAL_TOOLTIP_SHOWTIMES: 'global-tooltip__container--tsp-desktop',
}
function updateSubNavLocation(location) {
    const el = document.querySelector(Selectors.SUB_NAV_LOCATION);
    return el.innerText = location.zip || location.name;
}
function load() {
    const location = locationHelpers.getLocationFromURL(document.location.pathname) || getLocation();
    updateLocation(location);
    calendarUI.renderCalendar();
    updateSubNavLocation(location);
    hearts.init();
    movieShowtimeGroupings.init((clientSideTheaters) => {
        theaterConcessionAmenity.init(clientSideTheaters);
    });
    openChainFilter.init();
}
function onLocationChange() {
    const location = getLocation();
    historyStates.push(historyStates.HistoryEventTypes.LOCATION, location);
    updateLocationURL();
    load();
}
function run() {
    checkDependencies(module.name, debugLog);
    const tooltipOpts = {
        selector: Selectors.GLOBAL_TOOLTIP_PLACEHOLDER,
        page: globalTooltipModule.Pages.THEATER_SHOWTIMES,
        overrideClass: Styles.GLOBAL_TOOLTIP_SHOWTIMES,
    };
    globalTooltipModule.initInline(tooltipOpts);
    locationFormCreation.init({
        trigger: '#btn-location',
        dropdown: {
            name: 'desktopTheaterShowtimesModule',
            relativeParent: Selectors.LOCATION,
        }
    });
    locationFormCreation.attach(onLocationChange);
    resolveUrlLocation(load);
}
document.addEventListener('DOMContentLoaded', run);
export default {  };